import * as moment from "moment";
import {apiBase} from "./api";
import {localStorageGet, localStorageRemove, localStorageSet} from "../utils";

let sessionToken: Token = null;
let sessionTokenPromise: Promise<Token> = null;

const LS_TOKEN = "_session_token";

export interface Token {
    token: string;
    expiresOn: string;
    createdOn: string;
    validated: boolean;
    userId: string;
}

export function tokenValidated(isValid: boolean): void {
    if (sessionToken) {
        sessionToken.validated = isValid;
        localStorageSet(LS_TOKEN, JSON.stringify(sessionToken));
    }
}

export function setToken(token: Token): void {
    sessionToken = token;
    tokenValidated(!!token.userId);
}

export function deleteToken(): void {
    sessionToken = null;
    localStorageRemove(LS_TOKEN);
}

export function getToken(): Token {
    return sessionToken;
}

export function requestNewToken(storedToken?: Token): Promise<Token> {
    const options = {headers: {} as any};
    if (storedToken) {
        options.headers.Token = storedToken.token;
    }
    return fetch(apiBase() + "/auth/token", options)
        .then(results => {
            return results.json();
        });
}

export function ensureToken(): Promise<Token> {
    let storedToken: Token = null;
    if (!sessionToken && localStorageGet(LS_TOKEN)) {
        try {
            storedToken = JSON.parse(localStorageGet(LS_TOKEN));
            if (storedToken && moment(storedToken.expiresOn).isAfter(moment())) {
                sessionToken = storedToken;
                return Promise.resolve(storedToken);
            }
        } catch (e) {
            storedToken = null;
        }
    }
    if (sessionToken && moment(sessionToken.expiresOn).isAfter(moment())) {
        return Promise.resolve(sessionToken);
    }
    if (sessionTokenPromise) {
        return sessionTokenPromise;
    }
    sessionTokenPromise = requestNewToken(storedToken)
        .then(token => {
            sessionToken = token;
            sessionTokenPromise = null;
            localStorageSet(LS_TOKEN, JSON.stringify(sessionToken));
            return token;
        });
    return sessionTokenPromise;
}



// WEBPACK FOOTER //
// ./src/actions/token.ts